module.exports = __webpack_public_path__ + "ed6d5f37779af38911b0b7cb2212e30d.svg";